import React from "react";
import { Outlet } from "react-router-dom";

function Root() {
  return (
    <div className="ot-app h-[calc(100vh_-_90px)] md:h-[calc(100vh_-_100px)]">
      <div id="MainContentArea">
        <>
          <Outlet />
        </>
      </div>
    </div>
  );
}

export default Root;
